import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 22,
	viewBox: "0 0 41 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M38 3L23.5934 17.4685C21.892 19.1772 19.108 19.1772 17.4066 17.4685L3 3",
		stroke: "currentColor",
		strokeWidth: 5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgButtonArrowDown;
